window.Sparkle ??= {};

window.Sparkle = window.Sparkle || {};
window.Sparkle.Embed = window.Sparkle.Embed || {};
